module.exports = __webpack_public_path__ + "02_short_beige.bf2d84c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/02_short_beige.png
// module id = lmPQ
// module chunks = 0